import { render, staticRenderFns } from "./EditBongkarPage.vue?vue&type=template&id=a08d1d6c&scoped=true&"
import script from "./EditBongkarPage.vue?vue&type=script&lang=js&"
export * from "./EditBongkarPage.vue?vue&type=script&lang=js&"
import style0 from "./EditBongkarPage.vue?vue&type=style&index=0&id=a08d1d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d1d6c",
  null
  
)

export default component.exports